import { hasCompanyFeature } from 'utils/companyFeatureFlags';

/** Canonical settings path for the ChatFlow / Agents section. */
export default function agenticSectionPath(authCompany) {
  const hasAgentic = hasCompanyFeature(authCompany?.featureFlags, 'agenticChatFlow');
  return hasAgentic ? '/home/settings/agents' : '/home/settings/chatFlow';
}

export function agenticSectionName(authCompany) {
  const hasAgentic = hasCompanyFeature(authCompany?.featureFlags, 'agenticChatFlow');
  return hasAgentic ? 'agents' : 'chatFlow';
}
